export function formateDate(time, format) {
    // time无值时返回空
    if (!time) {
        return "";
    }
    var t = new Date(time);
    var tf = function (i) { return (i < 10 ? '0' : '') + i };
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
            case 'yyyy':
                return tf(t.getFullYear());
                break;
            case 'MM':
                return tf(t.getMonth() + 1);
                break;
            case 'mm':
                return tf(t.getMinutes());
                break;
            case 'dd':
                return tf(t.getDate());
                break;
            case 'HH':
                return tf(t.getHours());
                break;
            case 'ss':
                return tf(t.getSeconds());
                break;
        }
    })
}

export function getUuid(time, format) {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("").replace("-", "");
    return uuid
}


export function getParamJson(search) {
    //可接受两个参数
    //无参数时默认返回window.location.search 转换成JSON后的对象
    //1个参数时把此参数当成search看待
    //对多个同名的key不能用.
    var obj = {};
    search = search || window.location.search;
    var arr = search.replace(/^\?/g, '').replace(/\#/g, '').split('&');
    for (var i = 0; i < arr.length; i++) {
      var tmp = arr[i].split('=');
      obj[tmp[0]] = obj[tmp[0]] ? (obj[tmp[0]] instanceof Array) ? obj[tmp[0]].concat(tmp[1]) : [obj[tmp[0]], tmp[1]] : tmp[1];
      obj[tmp[0]] = decodeURIComponent(obj[tmp[0]]);
    }
    return obj;
  }

  export function formatHours (secondSub, ftype='D-h-min-s') {
    let ftypeArr = ftype.split('-');
    var days = Math.floor(secondSub / 24);     // 计算出小时数
    var leave1 = secondSub % 24;                // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1);              // 计算相差分钟数
    var leave2 = leave1 * 60 % 60;                       // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2);              // 计算相差秒数
    var leave3 = leave2 * 60 % 60;                           // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3);
    return (days && (days + ftypeArr[0])) + (hours && (hours + ftypeArr[1])) + (minutes && (minutes + ftypeArr[2])) + (seconds && (seconds + ftypeArr[3]));
  }